import React from 'react'
import { useCurrentUser } from '@/hooks/use-current-user'
import { useNotificationStore } from '@/providers/notification-store-provider'
import { useNotifications } from '@/views/landing/hooks/use-notifications'
import { signIn } from 'next-auth/react'

interface UseToggleNotificationProps {
  id: string
  price: number
  priceLowest: number
}

export type UseToggleNotificationReturnType = {
  onClickNotificationButton: (event: React.MouseEvent) => void
  notifiedStatus: 'loading' | 'notified' | 'unNotified'
  notifiedData?: {
    notificationId: string
    productId: string
  }
}

export const useToggleNotification = ({
  id,
  price,
  priceLowest,
}: UseToggleNotificationProps): UseToggleNotificationReturnType => {
  const { status: authStatus } = useCurrentUser()
  const { onClickDrawer } = useNotificationStore((state) => state)

  const { data, isLoading } = useNotifications({})

  const notifiedData = React.useMemo(
    () => data?.data.find(({ productId }) => productId === id),
    [data, id],
  )

  const notifiedStatus = React.useMemo(
    () => (isLoading ? 'loading' : notifiedData ? 'notified' : 'unNotified'),
    [isLoading, notifiedData],
  )

  const onClickNotificationButton = React.useCallback(
    (event: React.MouseEvent) => {
      const isLoggedInUser = authStatus === 'authenticated'

      event.preventDefault()
      if (!isLoggedInUser) {
        signIn()
      }
      onClickDrawer(notifiedStatus)({
        productId: id,
        price,
        priceLowest,
        notificationId: notifiedData?.notificationId,
      })
    },
    [
      authStatus,
      onClickDrawer,
      id,
      price,
      priceLowest,
      notifiedStatus,
      notifiedData,
    ],
  )
  return {
    onClickNotificationButton,
    notifiedStatus,
    notifiedData,
  }
}
